export const routes = {
  auth: {
    main: "/auth",
    register: "/auth/register",
    verifyAccount: "/auth/verify",
    setPassword: {
      linkSent: "/auth/set-password/link-sent",
      setPassword: "/auth/set-password/set-password",
      completed: "/auth/set-password/completed",
    },
    forgetPassword: {
      main: "/auth/forget-password",
      linkSent: "/auth/forget-password/link-sent",
      setPassword: "/auth/forget-password/set-password",
      completed: "/auth/forget-password/completed",
    },
  },
  profile: {
    main: "/profile",
  },
  setting: {
    main: "/setting",
  },
  jobPositions: {
    main: "/job-positions",
    add: "/job-positions/add",
    edit: "/job-positions/edit",
    preview: "/job-positions/preview/:id",
    view: "/job-positions/:id",
    candidate: "/job-positions/:id/candidate/:assignmentId",
  },
  postHiring: {
    main: "/post-hiring",
    employeeDetails: "/post-hiring/:id",
  },
  financial: {
    main: "/financial",
  },
  support: { main: "/support" },
  interviews: { main: "/interviews" },
  unauthorized: "/401",
  notFound: "*",
};
